const technicians =
{
    helmet :
    {
        title : 'Techniciens' ,
        metas : []
    }
};

export default technicians ;